import { DateRangeValue } from 'components/common/dateRangePicker';
import { isStringArray as isStringArrayGuard } from '../filterGuards';
import { Identificable } from 'shared/types/commonView';

export type EntityWithId = Identificable;

export type ScalarFilterValue = string | number | boolean | null | undefined;

export type MultiSelectFilterValue = string[] | null | undefined;

export type DataGridFilterValue =
  | ScalarFilterValue
  | MultiSelectFilterValue
  | DateRangeValue;

export type DataGridCellValue =
  | ScalarFilterValue
  | Date
  | Identificable[]
  | null
  | undefined;

export const isStringArray = isStringArrayGuard;

export const isEntityWithIdArray = (
  value: unknown
): value is Identificable[] =>
  Array.isArray(value) &&
  value.every(
    (item) =>
      item != null &&
      typeof item === 'object' &&
      typeof Reflect.get(item, '_id') === 'string'
  );
